import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { StyledHeaderTitle } from '../../../../ui';
import {
	IPageHeaderProps,
	PageHeader,
} from '../../../shared/layout/header/PageHeader';
import { HelloUserText } from '../shared/HelloUserText';
import { useUserStore } from '../../../auth/user/domain/stores/useUserStore';

export const AccountPageHeader = observer((props: IPageHeaderProps) => {
	const { page } = props;
	const { user } = useUserStore();
	return (
		<PageHeader {...props} hasCustomTitle>
			<StyledAccountHeaderTitleWrap>
				{user && <HelloUserText light />}
				<StyledHeaderTitle>{page.fields.title}</StyledHeaderTitle>
			</StyledAccountHeaderTitleWrap>
		</PageHeader>
	);
});

const StyledAccountHeaderTitleWrap = styled.div`
	${StyledHeaderTitle} {
		margin-top: 0;
		padding-top: 0;
	}
`;
